import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Cloudtrust() {
  return (
    <section className="cloud_trust p-100" style={{ background: "#F9F9F9" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/services-usa/cloud-cost/mastering_cloud.webp"
              alt="tekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={874}
              height={586}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <h2>
              Mastering Cloud Cost <span>Optimization</span>
            </h2>
            <p>
              To maximize digital stability and cloud cost optimization,
              companies must grasp the evolving nature of cloud economics.
              Usually, procuring IT infrastructure involves predictable asset
              refresh cycles, moving from requirements to proposals,
              negotiations, and awards. In contrast, the cloud’s flexibility
              introduces more demand-driven factors, requiring continuous
              decisions about services and specifications.
            </p>
            <p>
              Adopting a consumption-based approach to the cloud and continually
              aligning demand with the most relevant services and pricing models
              simplifies cloud cost optimization. This strategy enables you to
              sync your cloud expenses with business KPIs and directly link
              spending to ROI. Achieving this level of precision demands
              comprehensive visibility into your company’s cloud expenditures
              and accountability.
            </p>
            <p>
              Identifying where your cloud budget yields the highest value
              necessitates cost transparency and the visibility needed to
              integrate costs into the product lifecycle and automate cost
              governance.
            </p>
            <p>
              Discover how TekRevol can assist in optimizing your cloud costs,
              ensuring your investments deliver maximum value. Contact us to
              learn more.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudtrust;
